import { createFileRoute } from '@tanstack/react-router';

import { CitationBrowse } from '@/module/Author/Citation/CitationBrowse';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { proceedingId } = Route.useParams();
  return <CitationBrowse publicationId={proceedingId} />;
}
